import React from "react";
import loadable from "../utils/loadable";
import Spinner from "../components/loaders/Spinner";

// Dashboard
export const ActivityLogs = loadable(() => import("./ActivityLogs"), {
  fallback: <Spinner />
});

export const AffiliateSales = loadable(() => import("./AffiliateSales"), {
  fallback: <Spinner />
});

export const AlertNotification = loadable(() => import("./AlertNotification"), {
  fallback: <Spinner />
});

export const BlockReports = loadable(() => import("./BlockReports"), {
  fallback: <Spinner />
});

export const CommissionReport = loadable(() => import("./CommissionReport"), {
  fallback: <Spinner />
});

export const Dashboard = loadable(() => import("./Dashboard"), {
  fallback: <Spinner />
});

export const EmailUpdateLogs = loadable(() => import("./EmailUpdateLogs"), {
  fallback: <Spinner />
});

export const Franchise = loadable(() => import("./Franchise"), {
  fallback: <Spinner />
});

export const GasRequests = loadable(() => import("./GasRequests"), {
  fallback: <Spinner />
});

export const GstReports = loadable(() => import("./GstReports"), {
  fallback: <Spinner />
});

export const Login = loadable(() => import("./Login"), {
  fallback: <Spinner />
});

export const MannualWithrawRequest = loadable(
  () => import("./MannualWithrawRequest"),
  {
    fallback: <Spinner />
  }
);
export const MerchantRegistartionPage = loadable(
  () => import("./MerchantRegistartionPage"),
  {
    fallback: <Spinner />
  }
);
export const NotFound = loadable(() => import("./NotFound"), {
  fallback: <Spinner />
});
export const PayoutRequest = loadable(() => import("./PayoutRequest"), {
  fallback: <Spinner />
});

export const PayoutTransaction = loadable(() => import("./PayoutTransaction"), {
  fallback: <Spinner />
});
export const Purchase = loadable(() => import("./Purchase"), {
  fallback: <Spinner />
});
export const ReportStepOne = loadable(() => import("./ReportStepOne"), {
  fallback: <Spinner />
});

export const Sales = loadable(() => import("./Sales"), {
  fallback: <Spinner />
});
export const Setting = loadable(() => import("./Setting"), {
  fallback: <Spinner />
});
export const SubAdmin = loadable(() => import("./SubAdmin"), {
  fallback: <Spinner />
});
export const TdsReports = loadable(() => import("./TdsReports"), {
  fallback: <Spinner />
});
export const UserCommissionReport = loadable(
  () => import("./UserCommissionReport"),
  {
    fallback: <Spinner />
  }
);
export const UsernameUpdateLogs = loadable(
  () => import("./UsernameUpdateLogs"),
  {
    fallback: <Spinner />
  }
);
export const Users = loadable(() => import("./Users"), {
  fallback: <Spinner />
});
export const WalletAddressLogs = loadable(() => import("./WalletAddressLogs"), {
  fallback: <Spinner />
});
export const WalletAddressUpdateReq = loadable(
  () => import("./WalletAddressUpdateReq"),
  {
    fallback: <Spinner />
  }
);
export const WithdrawRequest = loadable(() => import("./WithdrawRequest"), {
  fallback: <Spinner />
});

export const WithdrawRewardHistory = loadable(
  () => import("./WithdrawRewardHistory"),
  {
    fallback: <Spinner />
  }
);
export const CardDetail = loadable(
  () => import("./Dashboard/Cards/CardDetail"),
  {
    fallback: <Spinner />
  }
);
export const DashboardCard = loadable(
  () => import("./Dashboard/Cards/DashboardCard"),
  {
    fallback: <Spinner />
  }
);
export const DashboardLanding = loadable(
  () => import("./Dashboard/DashboardLanding"),
  {
    fallback: <Spinner />
  }
);
export const NodeOwnerList = loadable(
  () => import("./Dashboard/NodeOwner/NodeOwnerList"),
  {
    fallback: <Spinner />
  }
);

export const ManageQr = loadable(() => import("./ManageQr"), {
  fallback: <Spinner />
});


export const FlagCount = loadable(() => import("./FlagCount"), {
  fallback: <Spinner />
});

export const FlagQuerry = loadable(() => import("./FlagQuerry"), {
  fallback: <Spinner />
});



export const PrivateRoute = loadable(() => import("./../PrivateRoute"), {
  fallback: <Spinner />
});
